export const GET_MOVIES_CONFIG = "GET_MOVIES_CONFIG";
export const GET_RECOMMENDED_MOVIES = "GET_RECOMMENDED_MOVIES";
export const GET_RECOMMENDED_SERIES = "GET_RECOMMENDED_SERIES";
export const GET_SEARCH_RESULTS = "GET_SEARCH_RESULTS";
export const GET_SHOW_DETAILS = "GET_MOVIE_DETAILS";
